export default "__VITE_ASSET___EVl7q2e__"